import axios from 'axios';
import { store } from '../redux/store';
import { loginSuccess, logout as logoutAction } from '../redux/slices/authSlice';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

// Add Authorization header if token exists
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let refreshPromise = null;
const fetchNewToken = () => {
  if (!refreshPromise) {
    refreshPromise = axiosInstance
      .post('/auth/refresh', {})
      .then((response) => response.data?.data)
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
};

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error;
    if (
      response?.status === 401 &&
      !config?._retry &&
      !config?.url?.includes('/auth/login') &&
      !config?.url?.includes('/auth/refresh')
    ) {
      config._retry = true;
      try {
        const data = await fetchNewToken();
        if (!data?.token) {
          throw new Error('Refresh failed');
        }
        const { token, user } = data;
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        store.dispatch(loginSuccess({ user, token }));
        config.headers.Authorization = `Bearer ${token}`;
        return axiosInstance(config);
      } catch (refreshErr) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        store.dispatch(logoutAction());
        return Promise.reject(refreshErr);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
